import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import * as f from '../logic';
import RestartIcon from '../../HOME/SVG/RestartIcon';
import SurrenderIcon from '../../HOME/SVG/SurrenderIcon';
import HelpIcon from '../../HOME/SVG/HelpIcon';
import OptionsIcon from '../../HOME/SVG/OptionsIcon';
import TrophyIcon from '../../HOME/SVG/TrophyIcon';
import PlaybackIcon from '../../HOME/SVG/PlayIcon';
import PlaybackStopIcon from '../../HOME/SVG/StopIcon';
import PlaybackPauseIcon from '../../HOME/SVG/PauseIcon';
import { pausePlayback } from '../REDUX/actions';
import { goToPage, showLeaderboards, requestSurrender, requestResetStats } from '../../HOME/REDUX/actions';
import { HELP_PAGE, GAME_PAGE } from '../../HOME/const';
import { windowSize } from '../../HOME/utils';

class Toolbar extends Component {
  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleSurrender = e => {
    this.props.hideOptions();

    if (f.canSurrender(this.props)) {
      if (f.winnerInfo(this.props).winner) {
        this.props.board.current.handleClickWinner();
      } else {
        this.props.requestSurrender(true);
      }

      this.props.requestResetStats(false);
    }
  };

  handleLeaders = () => {
    this.props.hideOptions();
    this.props.showLeaderboards();
  };

  handleHelp = () => {
    this.props.goToPage(HELP_PAGE, GAME_PAGE);
  };

  handlePlaybackPause = () => {
    this.props.pausePlayback();
  };

  handlePlaybackResume = () => {
    this.props.pausePlayback(true);
  };

  handlePlaybackStop = () => {
    this.props.board.current.stopPlayback();
  };

  render() {
    let { playback } = this.props;
    const mainToolbarVisibility = playback ? 'none' : 'inline';
    const playbackToolbarVisibility = playback ? 'inline' : 'none';
    const pausePlaybackVisibility = f.gameStarted(this.props) && !this.props.playbackPaused ? 'inline' : 'none';
    const resumePlaybackVisibility = this.props.playbackPaused ? 'inline' : 'none';
    const xmax = windowSize().x;
    const margin = Math.max(5, Math.min(10, xmax / 100));
    const solo = f.solo(this.props);
    const winner = f.winnerInfo(this.props).winner;

    const styles = {
      button: { marginLeft: margin, marginRight: margin },
    };

    return (
      <div className="toolbar">
        {/* MAIN TOOLBAR */}
        <span style={{ display: mainToolbarVisibility }}>
          <span
            className={`toolbar-button${f.canSurrender(this.props) ? '' : ' toolbar-button-disabled'}`}
            style={styles.button}
            onClick={this.handleSurrender}>
            {solo && !winner ? <SurrenderIcon width="36" /> : <RestartIcon width="36" />}
          </span>
          {solo && (
            <span className="toolbar-button" style={styles.button} onClick={this.handleLeaders}>
              <TrophyIcon width="36" />
            </span>
          )}
          <span className="toolbar-button" style={styles.button} onClick={this.handleHelp}>
            <HelpIcon width="36" />
          </span>
          <span className="toolbar-button" style={styles.button} onClick={this.props.onClickOptions}>
            <OptionsIcon width="36" id="options-button" />
          </span>
        </span>
        {/* PLAYBACK TOOLBAR */}
        <span style={{ display: playbackToolbarVisibility }}>
          <span className="toolbar-button" style={{ ...styles.button, display: pausePlaybackVisibility }} onClick={this.handlePlaybackPause}>
            <PlaybackPauseIcon width="36" />
          </span>
          <span className="toolbar-button" style={{ ...styles.button, display: resumePlaybackVisibility }} onClick={this.handlePlaybackResume}>
            <PlaybackIcon width="36" />
          </span>
          <span className="toolbar-button" style={styles.button} onClick={this.handlePlaybackStop}>
            <PlaybackStopIcon width="36" />
          </span>
        </span>
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { requestResetStats, requestSurrender, goToPage, showLeaderboards, pausePlayback }
)(Toolbar);
